import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './NoticePage.css';
import { API_URL } from '../lib/config';
import '../components/SideMenu.css'; // [수정] import 주석 해제

function NoticeDetailPage() {
    const { noticeId } = useParams();
    const [notice, setNotice] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchNoticeDetail = async () => {
            try {
                const response = await fetch(`${API_URL}/api/notices/${noticeId}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setNotice(data);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchNoticeDetail();
    }, [noticeId]);

    if (loading) return <div className="notice-page-container">공지사항을 불러오는 중...</div>;
    if (error) return <div className="notice-page-container error">공지사항을 불러오는데 실패했습니다: {error.message}</div>;
    if (!notice) return <div className="notice-page-container">해당 공지사항을 찾을 수 없습니다.</div>;

    const isEdited = new Date(notice.updatedAt) - new Date(notice.createdAt) > 60000;

    return (
        <div className="notice-page-container">
            <div id="bright-stars1"></div>
            <div id="bright-stars2"></div>
            <div id="bright-stars3"></div>
            
            <div className="notice-top-bar">
                <button className="back-button-icon" onClick={()=>navigate(-1)}>←</button>
                <div className="top-bar-title">공지사항 상세</div>
            </div>
            
            <main className="notice-main-content">
                <div className="notice-detail-body">
                    <h1>{notice.title}</h1>
                    <p className="notice-date">
                        작성일: {new Date(notice.createdAt).toLocaleDateString()}
                        {isEdited && (
                            <span className="edited-date">
                                수정일: {new Date(notice.updatedAt).toLocaleDateString()}
                            </span>
                        )}
                    </p>
                    <div className="content-area" dangerouslySetInnerHTML={{ __html: notice.content }} />
                </div>
            </main>
        </div>
    );
}

export default NoticeDetailPage;